module.exports = __webpack_public_path__ + "static/media/DSC_5594_HDR.91815da1.jpg";